import { cn } from '@/shared/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const badgeVariants = cva(
  'inline-flex items-center rounded-oval border px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        // /10 opacity는 커스텀 토큰에서 배경이 거의 안 보여 구분이 안 되므로 solid *-50 사용
        default: 'border-ruda-primary-200 bg-ruda-primary-50 text-ruda-primary',
        secondary: 'border-ruda-grey-200 bg-ruda-neutral-100 text-foreground',
        destructive:
          'border-ruda-error/20 bg-ruda-error-50 text-ruda-error',
        outline: 'border-ruda-grey-300 bg-white text-foreground',
        success:
          'border-ruda-success/20 bg-ruda-success-50 text-ruda-success',
        warning:
          'border-ruda-warning/20 bg-ruda-warning-50 text-ruda-warning',
        info: 'border-ruda-info/20 bg-ruda-info-50 text-ruda-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, ...props }: BadgeProps) => (
  <div className={cn(badgeVariants({ variant }), className)} {...props} />
);

export { Badge, badgeVariants };
